import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { map as map_1, head, tail, length, isEmpty, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { adminContent, ByCell, dateTimeCell, EntityName } from "./Prelude.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/EquipmentTypes.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, AssignDiscipline, Update } from "../Modals/EquipmentType.fs.js";
import { Components_UnDelete, Components_Delete } from "../Modals/Modal.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

function disciplineParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["disciplineId"]);
    }
    else {
        return new FSharpResult$2(0, [["disciplineId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("discipline", "Discipline", new FilterType(1, [projectId, new DomainEntities(4, []), empty(), disciplineParam])), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, m) {
    return new Row(m.Id, ofArray([new Cell("name", m.Name), new Cell("detail", defaultArg(map((value_1) => value_1, m.Detail), defaultOf())), new Cell("discipline", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(4, []),
        entityId: unwrap(m.DisciplineId),
    })), new Cell("lastModifiedOn", dateTimeCell(m.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: m.LastModifiedBy,
    }))]));
}

export function EquipmentTypes(equipmentTypesInputProps) {
    let actions, equipmentTypes, equipmentTypes_1;
    const projectId = equipmentTypesInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedEquipmentTypes = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "EquipmentTypes",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (equipmentTypeParams) => many(projectId, empty(), equipmentTypeParams),
        fetchCount: (equipmentTypeParams_1) => count(projectId, equipmentTypeParams_1),
        rowRender: (m) => rowRender(projectId, m),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedEquipmentTypes);
    const isMoreThan1 = length(selectedEquipmentTypes) !== 1;
    return adminContent(toList(delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Discipline"], ["onClick", (_arg_3) => {
        setAction("assignToDiscipline");
    }], ["disabled", isEmpty(selectedEquipmentTypes) ? true : showDeleted]]))))), delay(() => (showDeleted ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_4) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedEquipmentTypes)]]))))) : singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_5) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedEquipmentTypes)]])))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedEquipmentTypes) ? (isEmpty(tail(selectedEquipmentTypes)) ? createElement(Update, {
        projectId: projectId,
        equipmentType: head(selectedEquipmentTypes),
        close: close,
    }) : undefined) : undefined) : ((actions === "assignToDiscipline") ? createElement(AssignDiscipline, {
        projectId: projectId,
        equipmentTypes: selectedEquipmentTypes,
        close: close,
    }) : ((actions === "delete") ? ((equipmentTypes = map_1((Item) => (new DomainEntity(14, [Item])), selectedEquipmentTypes), createElement(Components_Delete, {
        projectId: projectId,
        entities: equipmentTypes,
        close: close,
    }))) : ((actions === "unDelete") ? ((equipmentTypes_1 = map_1((Item_1) => (new DomainEntity(14, [Item_1])), selectedEquipmentTypes), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: equipmentTypes_1,
        close: close,
    }))) : createElement(Create, {
        projectId: projectId,
        close: close,
    })))))) : undefined);
}

